// extracted by mini-css-extract-plugin
export default {"container":"lxtf4m","overlay":"wtxgqe","playerWrapper":"xQFh6B","hidden":"_Em5qI"};